import { render } from "./header.vue?vue&type=template&id=673f5dfe"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jmallach/Dev/jicub/vuejs-bosb-microsite/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__